<template>
  <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.15 0L0 2.15V12H9V0H2.15ZM1.5 5.25C1.5 4.825 1.825 4.5 2.25 4.5H3.25V7H1.5V5.25ZM5.25 10.5H2.25C1.825 10.5 1.5 10.15 1.5 9.75V9.25H5.25V10.5ZM5.25 8.75H1.5V7.5H5.25V8.75ZM5.25 7H3.75V4.5H5.25V7ZM7.5 9.75C7.5 10.15 7.175 10.5 6.75 10.5H5.75V7.5H7.5V9.75ZM7.5 7H5.75V4.5H6.75C7.175 4.5 7.5 4.825 7.5 5.25V7Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'PhoneCard',
};
</script>
